@if (actions(); as actions) {
  <app-action-buttons [actions]="actions" />
}
